'use strict';
require('whatwg-fetch');
